module.exports = __webpack_public_path__ + "static/img/1-8.de0b12b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/1-8.png
// module id = pllS
// module chunks = 15